import { BodyLinkV3 } from '@jouzen/ecom-components';
import type { RichTranslationValues } from 'next-intl';
import type { ReactNode } from 'react';

const getValues = (): RichTranslationValues => {
  return {
    footnoteLink: function footnoteLink(chunks: ReactNode) {
      return (
        <sup>
          <a href="#legal-footnotes">{chunks}</a>
        </sup>
      );
    },
    myAccountLink: function myAccountLink(chunks: ReactNode) {
      return (
        <BodyLinkV3 color="inherit" href="/my-account">
          {chunks}
        </BodyLinkV3>
      );
    },
    privacyPolicyLink: function privacyPolicyLink(chunks: ReactNode) {
      return (
        <BodyLinkV3 color="inherit" href="/privacy-policy">
          {chunks}
        </BodyLinkV3>
      );
    },
    ouraOnTheWebLink: function ouraOnTheWebLink(chunks: ReactNode) {
      return (
        <BodyLinkV3
          color="inherit"
          href="https://cloud.ouraring.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {chunks}
        </BodyLinkV3>
      );
    },
  };
};

export default getValues;
